import { DSComboboxT } from '@elliemae/ds-controlled-form';

// utils.ts
export const generateOptionsWithId = <T = DSComboboxT.OptionTypes>(
  options: { value?: string | number; label: string; type?: string }[],
): T[] => {
  return options.map(
    (option) =>
      ({
        dsId: `${option.value}-${Math.random().toString(36).substring(2, 9)}`, // Auto-generate dsId based on value and random string
        type: option.type || 'option', // Default to 'option' if type is not provided
        ...option,
      } as T),
  );
};
